import {AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {
  CmsFlexComponentData,
  OrderConfirmationListItemComponentTexts
} from '../order-confirmation/order-confirmation-list-item/order-confirmation-order-item.model';
import {DcpCartHistoryService} from '../services/dcp-cart-history.service';
import {CmsService, TranslationService} from '@spartacus/core';
import {
  SUPPORT_WIDGET_COMPONENT_CMS_ID,
  SupportWidgetCmsData
} from '../checkout-support-widget/checkout-support-widget.component';
import {JsonService} from '@dcp/configurator';
import {DcpCartService} from '@app/product/services/dcp-cart.service';
import {first} from 'rxjs/operators';
import {TransactionTypeService} from '@app/services/transactionTypes/transaction-type.service';
import {TransactionTypeDataService} from '../services/transaction-type-data.service';
import {RefreshCartService} from '../services/refresh-cart.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {DynamicHeadingService} from '@app/layout/header/dynamic-heading/dynamic-heading.service';
import {OrderEntry} from '@spartacus/cart/base/root/models/cart.model';
import {DefaultModalService} from '@app/shared/modal/services/default-modal.service';

@UntilDestroy()
@Component({
  selector: 'dcp-checkout-licenses',
  templateUrl: './checkout-licenses.component.html',
  styleUrls: ['./checkout-licenses.component.scss']
})
export class CheckoutLicensesComponent implements OnInit, AfterViewInit {

  private _cartEntry: OrderEntry;
  supportWidgetComponentData: SupportWidgetCmsData;
  transactionTypeEditModalHeadlineText: string;
  modalId: string;
  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  @Input() collapsable: boolean = false;
  @Input() collapsed: boolean = false;
  @Input() derivativeCount: number = 0;
  @Input() isInvalid: boolean;
  @Input() showPrice: boolean = false;
  @Input() showEditAction: boolean = false;
  @Input() showRemoveAction: boolean = false;
  @Input() componentTexts: OrderConfirmationListItemComponentTexts = {
    infoBar: '',
  };

  @Input() set cartEntry(value: OrderEntry) {
    this._cartEntry = value;
    this.transactionTypeService.getTransactionTypeByUrlOrOrderEntry(value).pipe(first(), untilDestroyed(this)).subscribe((value) => {
      this.transactionTypeEditModalHeadlineText = this.transactionTypeDataService.getLineItemTexts(value?.data)?.editModalHeadline;
      this.cdr.detectChanges();
    });
  }

  get cartEntry(): OrderEntry {
    return this._cartEntry;
  }

  private defaultModalTitle = '';

  constructor(
    public refreshCartService: RefreshCartService,
    private cartHistoryService: DcpCartHistoryService,
    private cartService: DcpCartService,
    private cmsService: CmsService,
    private translationService: TranslationService,
    private jsonService: JsonService,
    private dynamicHeadingService: DynamicHeadingService,
    private transactionTypeService: TransactionTypeService,
    private transactionTypeDataService: TransactionTypeDataService,
    private cdr: ChangeDetectorRef,
    protected modalService: DefaultModalService,
  ) {
  }

  ngOnInit() {
    this.mapSupportWidgetComponentData();
    this.translationService.translate('configurator.editAdditionalLicenses')
      .pipe(first(), untilDestroyed(this))
      .subscribe((translation) => {
        this.defaultModalTitle = translation;
      });
  }

  ngAfterViewInit() {
    if (this.refreshCartService.getEditCartModalOpen()) {
      this.openEditModal();
    }
  }

  mapSupportWidgetComponentData(): void {
    this.cmsService.getComponentData(SUPPORT_WIDGET_COMPONENT_CMS_ID)
      .pipe(untilDestroyed(this))
      .subscribe((data: CmsFlexComponentData) => {
        this.supportWidgetComponentData =
          this.jsonService.parseSafely(data?.classificationsProductData) as SupportWidgetCmsData;
      });
  }

  triggerRemoval(): void {
    this.cartHistoryService.removeEntry(this.cartEntry);
  }

  /**
   * Opens the modal and unsubscribes from cart changes in upper components.
   * To prevent this component from being destroyed unexpectedly.
   */
  openEditModal(): void {
    this.cartService.cartSubscriptionStatus.emit('unsubscribe');
    this.refreshCartService.setEditCartModalOpen(true);
    this.modalId = this.modalService.openModal(
      this.modalContent,
      this.transactionTypeEditModalHeadlineText || this.defaultModalTitle,
      undefined,
      {wide: true, type: 'basic', showHeader: false, customClasses: ['without-paddings', 'custom-footer']}
    );
    this.modalService.onClose().pipe(first(), untilDestroyed(this)).subscribe(() => {
      this.closeEditModal();
    });
  }

  closeEditModal(): void {
    this.cartService.cartSubscriptionStatus.emit('subscribe');
    this.refreshCartService.setEditCartModalOpen(false);
    this.dynamicHeadingService.setHeading(this.dynamicHeadingService.getCmsHeading());
  }
}
